import { render, staticRenderFns } from "./yuyan.vue?vue&type=template&id=209ab749&scoped=true&"
import script from "./yuyan.vue?vue&type=script&lang=js&"
export * from "./yuyan.vue?vue&type=script&lang=js&"
import style0 from "./yuyan.vue?vue&type=style&index=0&id=209ab749&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209ab749",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCardText,VCol,VSelect})
